import React, {Component} from 'react'
import {FormGroup, FormControl, ControlLabel, InputGroup, Glyphicon} from 'react-bootstrap'
import {Control, Errors, actions} from 'react-redux-form'
import PropTypes from 'prop-types';
import ArrowButton from '../../button-arrow';

import './file-upload.css'

class FileUpload extends Component {
  constructor(props) {
    super(props);
    this.state = {file: {name: ''}};
  }

  handleFileChange = (model, value) => {
    const reader = new FileReader();
    const file = value[0];

    const fileSize = this.checkFileSize(file.size);
    const fileType = this.checkFileType(file.type);

    const errors = [];

    if (!fileSize) {
      errors.push('size')
    }

    if (!fileType) {
      errors.push('type')
    }

    if (!errors.length) {
      reader.onloadend = () => {
        this.setState({
          file: file,
        });
        this.props.onFileLoaded && this.props.onFileLoaded(reader.result);
      };

      reader.readAsDataURL(file);
    } else {
      this.setState({
        file: {},
      });
      this.props.onFileLoaded && this.props.onFileLoaded(null);
    }

    return (dispatch) => {
      dispatch(actions.change(model, file));
      dispatch(actions.resetValidity(model));
    };
  };

  checkFileType = (type) => {
    return !type || !this.props.type || this.props.type.some((val) => val === type);
  };

  checkFileSize = (size) => {
    return !size || !this.props.sizeLimit || size < this.props.sizeLimit;
  };

  reset = () => {
    this.setState({file: {name: ''}});
  };

  render() {
    return (
      <div className="ignite-fileupload form-group">
        <h4>{this.props.label}{this.props.required && '*'}</h4>
        <FormGroup>
          <InputGroup>
            <FormControl type="text"
                         value={this.state.file.name}
                         readOnly/>

            <InputGroup.Button>
              <ControlLabel htmlFor={this.props.model} className="red-btn btn btn-default">
                  {this.props.buttonHasIcon && <Glyphicon glyph="folder-open"/>}
                  {this.props.buttonLabel}
              </ControlLabel>
            </InputGroup.Button>
          </InputGroup>
        </FormGroup>

        <Control.file className="fileInput"
                      id={this.props.model}
                      name={this.props.model}
                      model={this.props.model}
                      validators={{
                        fileSize: (val) => !val || this.checkFileSize(val.size),
                        fileType: (val) => !val || this.checkFileType(val.type),
                        required: (val) => !this.props.required || this.props.source || val
                      }}
                      changeAction={this.handleFileChange}/>

        <Errors
          show={true}
          className="errors"
          model={this.props.model}
          messages={{
            fileSize: `The selected file reaches the upload limit (${this.props.sizeLimit / 1024} Kb)`,
            fileType: 'The selected file is not a valid file',
            required: 'This field is required'
          }}/>
      </div>
    )
  }
}

FileUpload.propTypes = {
  model:         PropTypes.string.isRequired,
  label:         PropTypes.string,
  onFileLoaded:  PropTypes.func,
  type:          PropTypes.arrayOf(PropTypes.string),
  sizeLimit:     PropTypes.number,
  buttonLabel:   PropTypes.string,
  buttonHasIcon: PropTypes.bool,
  required:      PropTypes.bool
};

FileUpload.defaultProps = {
  model:         '.file',
  label:         'Upload a file',
  buttonLabel:   'Browse…',
  buttonHasIcon: true
};

export default FileUpload



// WEBPACK FOOTER //
// ./src/components/common/form/elements/file-upload.jsx